import { withRouter } from 'react-router-dom';
import SmartAssessment from './SmartAssessment';

export default withRouter(SmartAssessment);
